import React, { Fragment } from 'react';
import RecordsTable from './recordsTable';
import { useFetch } from '../../lib/useFetch';
import { userImg } from '../../lib/constants';
import { formatDate } from '../../lib/helpers';

const offerHeaders = ["Traveller", "First Name", "Last Name", "Trip From", "Trip To", "Trip Capacity",
  "Trip Date", "Start Date", "End Date"];

const mapResponseData = (data) => {
  const getTrimmedObj = (obj) => {
    let trimmedObj = {}
    trimmedObj['id'] = obj['_id'];
    trimmedObj['owner'] = { username: obj.owner.username, img: obj.owner.photo || userImg };
    trimmedObj['firstName'] = obj.owner.firstName
    trimmedObj['lastname'] = obj.owner.lastName
    trimmedObj['tripFrom'] = obj.tripDetails.tripFrom
    trimmedObj['tripTo'] = obj.tripDetails.tripTo
    trimmedObj['tripCapacity'] = obj.tripDetails.tripCapacity 
    trimmedObj['date'] = formatDate(new Date(obj.tripDetails.tripDate))
    trimmedObj['startDate'] = formatDate(new Date(obj.tripDetails.tripStartDate))
    trimmedObj['endDate'] = formatDate(new Date(obj.tripDetails.tripEndDate))
    
    return trimmedObj;
  }
  if (data) {
    return data.map(obj => getTrimmedObj(obj));
  }
  return [];
}

const Offers = ({ params }) => {
  const { data } = useFetch(`offers?${params}`);

  return (
    <Fragment>
      <RecordsTable
        headers={offerHeaders}
        records={mapResponseData(data)}
      />
    </Fragment>
  );
}
export default Offers;